import produce from "immer"
import { PUBLISHED, ASC } from "const"
import { QidCompany } from "server/models"
import { InferValueTypes } from "client/utils"
import * as types from "./types"
import * as actions from "./actions"

type ActionTypes = ReturnType<InferValueTypes<typeof actions>>

export const initQidCompany: QidCompany = {
    id: null,
    name: "",
    logoId: null,
    status: PUBLISHED,
}

const initQidCompanyState: types.QidCompanyState = {
    companyList: {},
    companyIds: [],
    companyView: initQidCompany,
    companyEdit: initQidCompany,

    sortColumn: "name",
    sortOrder: ASC,
    filters: {
        status: null,
        search: null,
    },

    reloadList: true,
    reloadView: true,
    reloadEdit: true,
}

const qidCompanyReducer = produce((
    draft: types.QidCompanyState = initQidCompanyState,
    action: ActionTypes = null,
): types.QidCompanyState => {
    switch (action.type) {
        case types.QID_COMPANY_LIST:
            draft.companyList = action.companyList
            return draft

        case types.QID_COMPANY_IDS:
            draft.companyIds = action.companyIds
            return draft

        case types.QID_COMPANY_VIEW:
            draft.companyView = action.company
            return draft

        case types.QID_COMPANY_EDIT:
            draft.companyEdit = action.company
            return draft

        case types.QID_COMPANY_SORT:
            draft.sortColumn = action.sortColumn
            draft.sortOrder = action.sortOrder
            return draft

        case types.QID_COMPANY_FILTERS:
            draft.filters = action.filters
            return draft

        case types.QID_COMPANY_RELOAD_LIST:
            draft.reloadList = action.value
            return draft

        case types.QID_COMPANY_RELOAD_VIEW:
            draft.reloadView = action.value
            return draft

        case types.QID_COMPANY_RELOAD_EDIT:
            draft.reloadEdit = action.value
            return draft

        default:
            return draft
    }
})
export default qidCompanyReducer
